import { ShipmentTrackerStatus } from "@redotech/redo-fulfillment-group-common/outbound-shipment-label";
import {
  default as CancelledIcon,
  default as ErrorIcon,
  default as FailureIcon,
  default as StalledInTransitIcon,
} from "@redotech/redo-icons/alert-hexagon_filled.svg";
import AvailableForPickupIcon from "@redotech/redo-icons/building-02_filled.svg";
import DeliveredIcon from "@redotech/redo-icons/check-circle_filled.svg";
import ReturnToSenderIcon from "@redotech/redo-icons/flip-backward_filled.svg";
import HelpIcon from "@redotech/redo-icons/help-circle.svg";
import PreTransitIcon from "@redotech/redo-icons/status.svg";
import {
  default as InTransitIcon,
  default as OutForDeliveryIcon,
} from "@redotech/redo-icons/truck-01_filled.svg";
import {
  RedoBadge,
  RedoBadgeColor,
} from "@redotech/redo-web/arbiter-components/badge/redo-badge";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";

const shipmentTrackerStatusToBadgeProperties: Record<
  ShipmentTrackerStatus,
  {
    text: string;
    color: RedoBadgeColor;
    Icon: React.JSXElementConstructor<any>;
  }
> = {
  [ShipmentTrackerStatus.UNKNOWN]: {
    text: "Unknown",
    color: "gray",
    Icon: HelpIcon,
  },
  [ShipmentTrackerStatus.PRE_TRANSIT]: {
    text: "Pre transit",
    color: "blue",
    Icon: PreTransitIcon,
  },
  [ShipmentTrackerStatus.IN_TRANSIT]: {
    text: "In transit",
    color: "blue",
    Icon: InTransitIcon,
  },
  [ShipmentTrackerStatus.OUT_FOR_DELIVERY]: {
    text: "Out for delivery",
    color: "blue",
    Icon: OutForDeliveryIcon,
  },
  [ShipmentTrackerStatus.AVAILABLE_FOR_PICKUP]: {
    text: "Ready for pickup",
    color: "blue",
    Icon: AvailableForPickupIcon,
  },
  [ShipmentTrackerStatus.DELIVERED]: {
    text: "Delivered",
    color: "success",
    Icon: DeliveredIcon,
  },
  [ShipmentTrackerStatus.RETURN_TO_SENDER]: {
    text: "Return to sender",
    color: "warning",
    Icon: ReturnToSenderIcon,
  },
  [ShipmentTrackerStatus.FAILURE]: {
    text: "Failure",
    color: "error",
    Icon: FailureIcon,
  },
  [ShipmentTrackerStatus.CANCELLED]: {
    text: "Cancelled",
    color: "error",
    Icon: CancelledIcon,
  },
  [ShipmentTrackerStatus.ERROR]: {
    text: "Error",
    color: "error",
    Icon: ErrorIcon,
  },
  [ShipmentTrackerStatus.STALLED_IN_TRANSIT]: {
    text: "Stalled in transit",
    color: "error",
    Icon: StalledInTransitIcon,
  },
};

export const ShipmentTrackerStatusBadge = memo(
  function ShipmentTrackerStatusBadge({
    shipmentTrackerStatus,
  }: {
    shipmentTrackerStatus: ShipmentTrackerStatus;
  }) {
    const { text, color, Icon } =
      shipmentTrackerStatusToBadgeProperties[shipmentTrackerStatus];
    return (
      <Flex flexDirection="column" justify="center">
        <RedoBadge
          color={color}
          segmentLeading={{ type: "icon", Icon }}
          size="xs"
          text={text}
          type="primary"
        />
      </Flex>
    );
  },
);
